// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseStatePlusSprite from "../../../../../engines/components/state/BaseStatePlusSprite";
import SettleLawsuitSuccessLayer from "../common/SettleLawsuitSuccessLayer";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SettleLawsuitMainSuccessLayer extends SettleLawsuitSuccessLayer {

	@property({ type: BaseStatePlusSprite, displayName:'' })
	spr_win_title_text: BaseStatePlusSprite = null;
    
    showProp(visible: boolean) {
        
    }

    initShow() {
        super.initShow();
        this.spr_win_title_text.setFill(this._carryData.bHighScore ? 1 : 0);
    }
}
